module.exports = __webpack_public_path__ + "static/media/calendar.c261bac9.svg";